import { useEffect, useState } from "react";
import { Input, Form, Select, Row, Col, Space } from "antd";
import { ColumnsType } from 'antd/es/table'
import { selectFilterOption, getOptionArray } from "@/lib/antdElementFunction";
import { getSubjectColumnsByOrder, getFormatData } from "@/lib/transcript";
import { getLangList } from '@/lib/i18n';
import ResponsiveTable from '@/components/responsiveTable';
import { StudentType } from "@/containers/humanResourceManagement/studentManagement/types";
import { ClassSubjectItems } from "@/containers/organization/classManagement/types";
import { TranscriptListType } from './types';

interface Props {
  form: any;
  studentArray: StudentType[];
  transcriptList: TranscriptListType;
  template: number;
  subjectListForExam: ClassSubjectItems;
}

function ModalBatchScoring(props: Props) {
  const { form, studentArray, transcriptList, template, subjectListForExam } = props;
  const [subjectOptions, setSubjectOptions] = useState<{ label: string, value: number }[]>([]);
  const [columns, setColumns] = useState<ColumnsType<StudentType>>([]);
  const [subjectId, setSubjectId] = useState();
  const formatedData = getFormatData(studentArray, transcriptList);
  const subjectT: any = getLangList("subject");
  const studentListT: any = getLangList("studentList");

  useEffect(() => {
    const dynamicColumns = getSubjectColumnsByOrder(template, subjectListForExam);
    const subjectOptions = dynamicColumns.map((item) => {
      return { label: item.title, value: item.dataIndex };
    })

    const targetSubject = dynamicColumns?.find((subject) => subject.dataIndex === subjectId);
    const dynamicColumn: any = {
      title: targetSubject?.title,
      dataIndex: subjectId,
      width: 100,
      render: (text: number, record: StudentType) => (
        <Form.Item name={`${record.userAccountId}-${subjectId}`}>
          <Input />
        </Form.Item>
      ),
    };

    const columns = [
      { title: studentListT.ACCOUNT, dataIndex: "username" },
      { title: studentListT.CN_NAME, dataIndex: "nameCn" },
      { title: studentListT.EN_NAME, dataIndex: "nameEn" },
    ];
    subjectId && columns.push(dynamicColumn);

    formatedData.forEach((item) => {
      const { userAccountId } = item;
      subjectId && form.setFieldsValue({ [`${userAccountId}-${subjectId}`]: item[subjectId] });
    });

    setSubjectOptions(subjectOptions);
    setColumns(columns);
  }, [form, subjectId, template]);

  return (
    <Row className="modal-batch-scoring" gutter={[0, 12]} justify="center">
      <Col>
        <Space>
          {`${subjectT.SUBJECT}:`}
          <Select
            showSearch
            optionFilterProp="children"
            filterOption={(input: any, option: any) => selectFilterOption(input, option)}
            value={subjectId}
            onChange={setSubjectId}
            style={{ width: '300px' }}
          >
            {getOptionArray(subjectOptions)}
          </Select>
        </Space>
      </Col>

      <Col span={24}>
        <Form
          className="admin-form"
          style={{ marginTop: 20 }}
          labelCol={{ lg: { span: 8 }, xs: { span: 24 }, sm: { span: 8 } }}
          wrapperCol={{ lg: { span: 16 }, xs: { span: 24 }, sm: { span: 16 } }}
          form={form}
        >
          <ResponsiveTable
            dataSource={formatedData}
            columns={columns}
            fixedRight={false}
          />
        </Form>
      </Col>
    </Row>
  );
}

export default ModalBatchScoring;